export const renderContent = (text: string) => {
  const parts = text.split(/(@mustard)/g);
  return parts.map((part, index) => {
    if (part === "@mustard") {
      return (
        <span key={index} style={{ color: "blue" }}>
          @mustard
        </span>
      );
    }
    return part;
  });
};
